<template>
    <UFormField v-bind="$attrs" :ui="resolveComponentUi(ui)">
        <template v-for="slotName in slotNames" #[slotName]="slotProps">
            <slot :name="slotName" v-bind="slotProps ?? {}" />
        </template>
    </UFormField>
</template>

<script setup lang="ts">
    import {
        BrFormFieldVariants,
        type BrFormFieldVariant
    } from '@/assets/css/themes/custom-components/constants/br-form-field';

    defineOptions({ inheritAttrs: false });

    const props = defineProps({
        variant: {
            type: String as PropType<BrFormFieldVariant>,
            default: BrFormFieldVariants.SoftInset
        }
    });

    const slots = useSlots();
    const slotNames = computed(() => Object.keys(slots));

    const ui = useComponentUi('brFormField', () => ({
        variant: props.variant
    }));
</script>
